export default "__VITE_ASSET__664b633e__"